<mat-accordion>
  <mat-expansion-panel class="md-expansion-demo-width" #myPanel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="col-md-6">
          <h6>Reserves and Alternate Source Details</h6>
        </div>
        <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
          <h6>Site Id: {{ siteId }}</h6>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- UPS Details -->
    <br />
    <mat-expansion-panel
      class="md-expansion-demo-width"
      #upsDetailsPanel
      expanded="true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title><h6>UPS Details</h6></mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="formdata" #formDirective="ngForm" novalidate>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input"
                >Make<span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  formControlName="makeCtr"
                  [(ngModel)]="altSourcesDetails.make"
                  placeholder="Brand / Model"
                  required
                />
                <mat-error
                  *ngIf="formdata.get('makeCtr').hasError('whitespace')"
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input"
                >Inverter Capacity (KVA)<span class="iep-required"
                  >*</span
                ></mat-label
              >
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  formControlName="inverterCapacityCtr"
                  [(ngModel)]="altSourcesDetails.inverterCapacity"
                  type="number"
                  step="0.01"
                  class="form-control"
                  style="width: 125%; padding-right: 2px; margin-top: 3px"
                  placeholder="Inverter Capacity (KVA)"
                  required
                />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input"
                >Backup time (Hours)<span class="iep-required"
                  >*</span
                ></mat-label
              >
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  formControlName="backupTimeCtr"
                  [(ngModel)]="altSourcesDetails.backupTime"
                  type="number"
                  step="0.01"
                  placeholder="In Hours"
                  required
                />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <mat-label class="label-input"
              ><u>Battery Bank Details</u></mat-label
            >
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">No Of Batteries</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  formControlName="noOfBatteriesCtr"
                  [(ngModel)]="altSourcesDetails.noOfBatteries"
                  type="text"
                  placeholder="No Of Batteries"
                />
                <mat-error
                  *ngIf="isFieldHasError('noOfBatteriesCtr', 'pattern')"
                >
                  Only numbers are allowed.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input"> Battery Details</mat-label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  formControlName="batteryMakeCtr"
                  [(ngModel)]="altSourcesDetails.batteryMake"
                  placeholder="Battery Make (Brand / Model)"
                />
                <mat-error
                  *ngIf="isFieldHasError('batteryMakeCtr', 'whitespace')"
                  >Please enter valid text.</mat-error
                >
              </mat-form-field>
            </div>

            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <mat-select
                  formControlName="batteryTypeCtr"
                  [(ngModel)]="altSourcesDetails.batteryType.rId"
                  placeholder="Select Battery Type"
                >
                  <mat-option
                    *ngFor="let option of batteryTypes"
                    value="{{ option.rId }}"
                    >{{ option.text }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  formControlName="batteryRatingCtr"
                  type="text"
                  [(ngModel)]="altSourcesDetails.batteryRating"
                  placeholder="Battery Rating"
                />
                <mat-error
                  *ngIf="isFieldHasError('batteryRatingCtr', 'pattern')"
                >
                  Only numbers are allowed.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  formControlName="dischargingCurrentCtr"
                  type="text"
                  [(ngModel)]="altSourcesDetails.dischargingCurrent"
                  placeholder="Discharging Current"
                />
                <mat-error
                  *ngIf="isFieldHasError('dischargingCurrentCtr', 'pattern')"
                >
                  Only numbers are allowed.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  formControlName="chargingCurrentCtr"
                  type="text"
                  [(ngModel)]="altSourcesDetails.chargingCurrent"
                  placeholder="Charging Current"
                />
                <mat-error
                  *ngIf="isFieldHasError('chargingCurrentCtr', 'pattern')"
                >
                  Only numbers are allowed.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <mat-select
                  formControlName="soCMeasurementTypeCtr"
                  [(ngModel)]="altSourcesDetails.soCMeasurementType.rId"
                  placeholder="SoC Measurement Type"
                >
                  <mat-option
                    *ngFor="let option of soCMeasurementTypes"
                    value="{{ option.rId }}"
                    >{{ option.text }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  formControlName="chargeTimeCtr"
                  type="number"
                  step="0.01"
                  [(ngModel)]="altSourcesDetails.chargeTime"
                  placeholder="Charge time (Hours)"
                />
              </mat-form-field>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  formControlName="impedanceCtr"
                  type="text"
                  [(ngModel)]="altSourcesDetails.impedance"
                  placeholder="Impedance &#937;"
                />
                <mat-error *ngIf="isFieldHasError('impedanceCtr', 'pattern')">
                  Only numbers are allowed.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Bank Connection</mat-label>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <mat-select
                  formControlName="bankConnectionTypesCtr"
                  [(ngModel)]="altSourcesDetails.bankConnection.rId"
                  placeholder="Select Bank Connection Type"
                >
                  <mat-option
                    *ngFor="let option of bankConnectionTypes"
                    value="{{ option.rId }}"
                    >{{ option.text }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input"
                >Commissioned Date<span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  formControlName="commissionedDateCtr"
                  [(ngModel)]="form.commissionedDate"
                  data-date-format="YYYY-MM-DD"
                  placeholder="Select Date"
                  name="selUPSCommissionedDatePicker"
                  [matDatepicker]="commissionedDatepicker"
                  [max]="max"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="commissionedDatepicker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #commissionedDatepicker
                  [startView]="startView"
                  disabled="false"
                >
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Service Interval </mat-label>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  formControlName="serviceIntervalCtr"
                  [(ngModel)]="altSourcesDetails.serviceInterval"
                  type="number"
                  step="0.01"
                  placeholder="In Hours"
                />
              </mat-form-field>
            </div>
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input"
                >Last Serviced Date<span class="iep-required"
                  >*</span
                ></mat-label
              >
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  formControlName="lastServicedDateCtr"
                  [(ngModel)]="form.lastServicedDate"
                  placeholder="Select Date"
                  name="selUPSLastServicedDatePicker"
                  [matDatepicker]="lastServicedDatepicker"
                  [max]="max"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="lastServicedDatepicker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #lastServicedDatepicker
                  [startView]="startView"
                  disabled="false"
                >
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">DOD </mat-label>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  formControlName="dodCtr"
                  [(ngModel)]="altSourcesDetails.dod"
                  type="number"
                  step="0.01"
                  placeholder="Max Permitted Discharge (%)"
                />
              </mat-form-field>
            </div>
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Bank Capacity</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  formControlName="bankCapacityCtr"
                  type="number"
                  step="0.01"
                  [(ngModel)]="altSourcesDetails.bankCapacity"
                  placeholder="Bank Capacity"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
    <!-- DG -->
    <br />
    <mat-expansion-panel
      class="md-expansion-demo-width"
      #dGPanel
      expanded="true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title><h6>DG</h6></mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="formDG" #formDirective="ngForm" novalidate>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <mat-label class="subTitle">Available Diesel Generators</mat-label>
            <br />
          </div>
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 notification"
            style="overflow: auto"
          >
            <mat-table #table [dataSource]="dgSources">
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>

                <mat-cell *matCellDef="let dgSource"
                  >{{ dgSource.name }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="make">
                <mat-header-cell *matHeaderCellDef>Make</mat-header-cell>
                <mat-cell *matCellDef="let dgSource">{{
                  dgSource.make
                }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="capacity">
                <mat-header-cell *matHeaderCellDef
                  >Capacity(KVA)</mat-header-cell
                >
                <mat-cell *matCellDef="let dgSource">{{
                  dgSource.capacity
                }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="maxOperatingPoint">
                <mat-header-cell *matHeaderCellDef
                  >Max Operating Point(%)</mat-header-cell
                >
                <mat-cell *matCellDef="let dgSource">{{
                  dgSource.maxOperatingPoint
                }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="fuelPrice">
                <mat-header-cell *matHeaderCellDef
                  >Fuel Price(Rs/L)</mat-header-cell
                >
                <mat-cell *matCellDef="let dgSource">{{
                  dgSource.fuelPrice
                }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="fuelRatekwh">
                <mat-header-cell *matHeaderCellDef
                  >Fuel Consumption Rate(L/KWh)</mat-header-cell
                >
                <mat-cell *matCellDef="let dgSource">{{
                  dgSource.fuelRatekwh
                }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="meterId">
                <mat-header-cell *matHeaderCellDef>Meter ID</mat-header-cell>
                <mat-cell *matCellDef="let dgSource">{{
                  dgSource.connectedMeter.meterId
                }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="insiteMeterID">
                <mat-header-cell *matHeaderCellDef
                  >In-site Meter ID</mat-header-cell
                >
                <mat-cell *matCellDef="let dgSource">{{
                  dgSource.connectedMeter.insiteMeterID
                }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="hasFlowMeter">
                <mat-header-cell *matHeaderCellDef
                  >Has Fuel Meter?</mat-header-cell
                >
                <mat-cell *matCellDef="let dgSource">{{
                  dgSource.hasFlowMeter
                }}</mat-cell>
              </ng-container>

              <mat-header-row
                *matHeaderRowDef="displayedColumns"
              ></mat-header-row>
              <mat-row
                *matRowDef="let dgSource; columns: displayedColumns"
              ></mat-row>
            </mat-table>

            <mat-paginator
              #paginator
              [pageSize]="5"
              [pageSizeOptions]="[5, 10, 20]"
            >
            </mat-paginator>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <button
              class="btn btn-success"
              id="addDGbtn"
              (click)="showAddNewDGForm()"
            >
              Add New DG
            </button>
            <button
              class="btn btn-warning cancelstyle"
              id="cancelDGbtn"
              (click)="clearAddNewDGForm()"
              *ngIf="addNewDG"
            >
              Cancel
            </button>
          </div>
        </div>

        <div class="row" *ngIf="addNewDG">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">DG Name </mat-label>
              </div>
              <div class="col-md-2">
                <mat-form-field>
                  <input
                    matInput
                    formControlName="dgNameCtr"
                    [(ngModel)]="altSourcesDetails.dgName"
                    id="dgName"
                    required
                    placeholder="DG Name"
                  />
                  <mat-error>This field is required.</mat-error>
                  <mat-error *ngIf="isFieldHasErrors('dgNameCtr', 'whitespace')"
                    >Please enter valid text.</mat-error
                  >
                </mat-form-field>
              </div>
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">DG Make </mat-label>
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                <mat-form-field>
                  <input
                    matInput
                    formControlName="dgMakeCtr"
                    [(ngModel)]="altSourcesDetails.dgMake"
                    id="dgMake"
                    required
                    placeholder="DG Make"
                  />
                  <mat-error>This field is required.</mat-error>
                  <mat-error *ngIf="isFieldHasErrors('dgMakeCtr', 'whitespace')"
                    >Please enter valid text.</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">DG Capacity(KVA) </mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-form-field>
                  <input
                    type="number"
                    min="1"
                    step="0.01"
                    matInput
                    formControlName="dgCapacityCtr"
                    [(ngModel)]="altSourcesDetails.dgCapacity"
                    id="dgCapacity"
                    required
                    placeholder="DG Capacity (KVA)"
                  />
                  <mat-error>This field is required.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input"
                  >Max Operating Point(%)
                </mat-label>
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                <mat-form-field>
                  <input
                    type="text"
                    placeholder="Max Operating Point(%)"
                    matInput
                    formControlName="maxOperatingPointCtr"
                    [(ngModel)]="altSourcesDetails.maxOperatingPoint"
                  />
                  <mat-error
                    *ngIf="
                      isFieldHasErrors('maxOperatingPointCtr', 'maxlength')
                    "
                  >
                    Please lengthen this value upto 3 digits.
                  </mat-error>
                  <mat-error
                    *ngIf="isFieldHasErrors('maxOperatingPointCtr', 'pattern')"
                  >
                    Only numbers are allowed.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Fuel Price(Rs/L) </mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-form-field>
                  <input
                    type="number"
                    step="0.01"
                    min="0.1"
                    matInput
                    formControlName="fuelPriceCtr"
                    [(ngModel)]="altSourcesDetails.fuelPrice"
                    required
                    id="fuelPrice"
                    placeholder="Fuel Price (Rs/L)"
                  />
                  <mat-error>This field is required.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input"
                  >Fuel Consumption Rate(L/KWh)
                </mat-label>
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                <mat-form-field>
                  <input
                    type="text"
                    matInput
                    formControlName="fuelRateCtr"
                    [(ngModel)]="altSourcesDetails.fuelRate"
                    placeholder="Fuel Consumption Rate (L/KWh)"
                  />
                  <mat-error *ngIf="isFieldHasErrors('fuelRateCtr', 'pattern')">
                    Only numbers are allowed.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Commissioned Date</mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-form-field>
                  <input
                    matInput
                    formControlName="dGCommissionedDatePicker"
                    [(ngModel)]="form.dgCommissionedDate"
                    placeholder="Select Date"
                    [matDatepicker]="dGCommissionedDatePicker"
                    [max]="max"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="dGCommissionedDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #dGCommissionedDatePicker
                    [startView]="startView"
                    disabled="false"
                  ></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Last Serviced Date </mat-label>
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                <mat-form-field>
                  <input
                    matInput
                    formControlName="dgLastServicedDatePicker"
                    [(ngModel)]="form.dgLastServicedDate"
                    placeholder="Select Date"
                    [matDatepicker]="dgLastServicedDatePicker"
                    [max]="max"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="dgLastServicedDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #dgLastServicedDatePicker
                    [startView]="startView"
                    disabled="false"
                  ></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Select Energy Meter</mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-form-field>
                  <mat-select
                    formControlName="dgEnergyMeterObjCtr"
                    [(ngModel)]="form.dgEnergyMeterObj"
                    id="dgEnergyMeter"
                    placeholder="Select a Meter"
                  >
                    <mat-option value="">Select a Meter</mat-option>
                    <mat-option
                      *ngFor="let dgM of unAssignedDGMeters"
                      [value]="dgM"
                      >{{ dgM.meterId }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Has Flow Meter?</mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <section class="sectionStyle">
                  <mat-radio-button
                    id="dgHasFlowMeter"
                    #flowYes
                    value="yes"
                    (change)="setFlowMeter('yes')"
                    >Yes</mat-radio-button
                  >
                  <mat-radio-button
                    id="dgHasNoFlowMeter"
                    #flowNo
                    value="no"
                    (change)="setFlowMeter('no')"
                    [checked]="true"
                    >No</mat-radio-button
                  >
                </section>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
              <p
                *ngIf="showErrorForNewDG"
                style="color: red; margin-bottom: 3px"
              >
                Enter DG details and select a Energy Meter For this DG
              </p>
            </div>
          </div>

          <div class="row">
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              *ngIf="altSourcesDetails.hasFlowMeter"
            >
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">
                  <u>Flow Meter Details</u></mat-label
                >
              </div>
            </div>
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              *ngIf="altSourcesDetails.hasFlowMeter"
            >
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Flow Meter Role</mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-form-field>
                  <mat-select
                    formControlName="flowMeterRoleCtr"
                    [(ngModel)]="altSourcesDetails.flowMeterRole"
                    value="{{ 'Fuel' }}"
                    name="flowMeterRole"
                    placeholder="Flow Meter Role"
                    disabled
                  >
                    <mat-option value="">Flow Meter Role</mat-option>
                    <mat-option
                      *ngFor="let fmRole of ChooseFlowMeterRole"
                      value="{{ fmRole.FmeterRole }}"
                      >{{ fmRole.FmeterRole }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Flow Meter Make</mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-form-field>
                  <input
                    matInput
                    formControlName="flowMeterMakeCtr"
                    placeholder="Enter Meter Make"
                    id="flowMeterMake"
                    type="text"
                    [(ngModel)]="altSourcesDetails.flowMeterMake"
                    required
                  />
                  <mat-error>This field is required.</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              *ngIf="altSourcesDetails.hasFlowMeter"
            >
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Flow Meter Serial No</mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-form-field>
                  <input
                    matInput
                    formControlName="flowMeterSerialNoCtr"
                    placeholder="Enter Serial No"
                    id="flowMeterSerialNo"
                    type="number"
                    [(ngModel)]="altSourcesDetails.flowMeterSerialNo"
                    required
                  />
                  <mat-error>This field is required.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Flow Meter InSite ID</mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-form-field>
                  <input
                    matInput
                    formControlName="flowMeterInsiteMeterIDCtr"
                    placeholder="Enter InSite Meter ID"
                    id="flowMeterInsiteID"
                    type="number"
                    [(ngModel)]="altSourcesDetails.flowMeterInsiteID"
                    required
                  />
                  <mat-error>This field is required.</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              *ngIf="altSourcesDetails.hasFlowMeter"
            >
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">Flow Meter Meter ID</mat-label>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-form-field>
                  <input
                    matInput
                    formControlName="flowMeterMeterIDCtr"
                    placeholder="Enter Meter ID"
                    id="flowMeterID"
                    type="number"
                    [(ngModel)]="altSourcesDetails.flowMeterID"
                    required
                  />
                  <mat-error>This field is required.</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
    <!-- Alternate Sources -->
    <br />
    <mat-expansion-panel
      class="md-expansion-demo-width"
      #alternateSourcesPanel
      expanded="true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title><h6>Alternate Sources</h6></mat-panel-title>
      </mat-expansion-panel-header>

      <form [formGroup]="formAlternate" #formDirective="ngForm" novalidate>
        <div class="row">
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <mat-label class="label-input"
              >Solar Sources - Additional Details</mat-label
            >
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <mat-label style="font-size: 16px">1.Define Area</mat-label>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-label class="label-input">Select Level</mat-label>
          </div>

          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-form-field>
              <mat-select
                formControlName="siteAndAreaLevelCtr"
                [(ngModel)]="altSourcesDetails.siteAndAreaLevel"
                placeholder="Select Level"
              >
                <mat-option value="">Select Level</mat-option>
                <mat-option
                  *ngFor="let option of siteAndAreaLevel"
                  value="{{ option }}"
                  >{{ option }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-label class="label-input">Expected Daily Output</mat-label>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-form-field>
              <input
                matInput
                type="number"
                formControlName="expectedSolarDailyOutputCtr"
                [(ngModel)]="altSourcesDetails.expectedSolarDailyOutput"
                id="slrExpectedOutput"
                required
                placeholder="Daily Output kWh"
              />
            </mat-form-field>
          </div>
        </div>

        <div
          class="row"
          *ngIf="altSourcesDetails.siteAndAreaLevel === 'Area Level'"
        >
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-label class="label-input">Select Area</mat-label>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-form-field>
              <mat-select
                id="solarAreaNames"
                formControlName="solarAreaNamesCtr"
                [(ngModel)]="altSourcesDetails.solarAreaNames.name"
                placeholder="Select Area"
              >
                <mat-option value="">Select Area</mat-option>
                <mat-option
                  *ngFor="let option of solarAreasOfThisSite"
                  value="{{ option.name }}"
                  >{{ option.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="altSourcesDetails.siteAndAreaLevel === 'Area Level'">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Installed Capacity</mat-label>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  formControlName="installedCapacityCtr"
                  [(ngModel)]="altSourcesDetails.installedCapacity"
                  id="installedCapacity"
                  required
                  placeholder="Capacity"
                />
                <mat-error
                  *ngIf="
                    formAlternate
                      .get('installedCapacityCtr')
                      .hasError('required')
                  "
                  class="help-block"
                  >This field is required.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>

        <div *ngIf="altSourcesDetails.siteAndAreaLevel === 'Site Level'">
          <div class="row">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Site Level</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  formControlName="siteLevelNumericIdCtr"
                  [(ngModel)]="altSourcesDetails.siteLevelNumericId"
                  id="siteLevelId"
                  placeholder="Numeric Site Id"
                  [readonly]="siteIdReadOnly"
                />
              </mat-form-field>
            </div>

            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Solar Layout</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <input
                type="file"
                id="uploadSolarLayout"
                (change)="uploadDocument($event, 'Solar_Layout')"
                class="hidden"
                accept=".jpeg,.jpg,.png,.jpe,image/jpeg,image/png"
              />
              <button
                type="button"
                bciprimarybutton
                class="button-primary"
                (click)="selectDocument('uploadSolarLayout')"
                matTooltip="Select layout picture"
                style="margin-top: 1em"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="edit icon"
                    class="bosch-ic-paperclip"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
              {{ solarlayoutAttachment.name }}
            </div>
          </div>

          <div class="row">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">PV Module</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  formControlName="pVModuleCtr"
                  [(ngModel)]="altSourcesDetails.pVModule"
                  id="pvmodule"
                  required
                  placeholder="PV Module"
                />
              </mat-form-field>
            </div>

            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Module No.</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  formControlName="moduleNoCtr"
                  [(ngModel)]="altSourcesDetails.moduleNo"
                  id="moduleno"
                  required
                  placeholder="Module No"
                />
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Module Wp</mat-label>
              <br />
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  formControlName="moduleWpCtr"
                  [(ngModel)]="altSourcesDetails.moduleWp"
                  class="form-control"
                  id="modulewp"
                  required
                  placeholder="Module Wp"
                />
              </mat-form-field>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Inverter Type</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  formControlName="inverterTypeCtr"
                  [(ngModel)]="altSourcesDetails.inverterType"
                  id="InverterType"
                  placeholder="Inverter Type"
                />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-label class="label-input"
              >Select Orientation<span class="iep-required">*</span></mat-label
            >
          </div>

          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-form-field>
              <mat-select
                formControlName="orientationCtr"
                [(ngModel)]="altSourcesDetails.orientation"
                placeholder="Select Orientation"
                required
              >
                <mat-option value="">Select Orientation</mat-option>
                <mat-option
                  *ngFor="let option of orientation"
                  value="{{ option }}"
                  >{{ option }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-label class="label-input">Tilt </mat-label>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-form-field>
              <input
                matInput
                type="number"
                id="slrTilt"
                formControlName="tiltCtr"
                [(ngModel)]="altSourcesDetails.tilt"
                placeholder="Tilt"
                required
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-label class="label-input"
              >Include in Area wise Summary?</mat-label
            >
          </div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-checkbox
              formControlName="solarAreaWiseSummaryCtr"
              [(ngModel)]="altSourcesDetails.solarAreaWiseSummary"
              style="margin-top: 1em"
            >
            </mat-checkbox>
          </div>
        </div>

        <div *ngIf="altSourcesDetails.siteAndAreaLevel === 'Site Level'">
          <div class="row">
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Has Temperature Sensor?</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <section #siteAndAreaLevel class="sectionStyle">
                <mat-radio-button
                  value="yes"
                  (change)="setTemperatureSensor('yes')"
                  >Yes</mat-radio-button
                >
                <mat-radio-button
                  value="no"
                  (change)="setTemperatureSensor('no')"
                  [checked]="true"
                  >No</mat-radio-button
                >
              </section>
            </div>
          </div>

          <div class="row">
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              *ngIf="altSourcesDetails.hasTempSensor"
            >
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input">
                  <u>Temperature Sensor Details</u></mat-label
                >
              </div>
            </div>
          </div>

          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
            *ngIf="altSourcesDetails.hasTempSensor"
          >
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Name</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  formControlName="flowChannelNameCtr"
                  [(ngModel)]="altSourcesDetails.newSolarTemp.name"
                  id="tempSensorName"
                  required
                  placeholder="Sensor Name"
                />
              </mat-form-field>
            </div>
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Flow Channel Serial No </mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  formControlName="ioChannnelSerialNumberCtr"
                  [(ngModel)]="
                    altSourcesDetails.newSolarTemp.ioChannnelSerialNumber
                  "
                  id="tempSensorIOSrlNo"
                  required
                  placeholder="IO Channel Serial No"
                />
              </mat-form-field>
            </div>
          </div>

          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
            *ngIf="altSourcesDetails.hasTempSensor"
          >
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-label class="label-input">Flow Channel ID</mat-label>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  formControlName="flowChannelIDCtr"
                  [(ngModel)]="altSourcesDetails.newSolarTemp.flowChannelID"
                  id="tempSensorFlowChannel"
                  required
                  placeholder="Flow Channel ID"
                />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <mat-label class="label-input">2.Add Irradiance Sensor</mat-label>
          </div>
        </div>

        <div
          class="row"
          *ngIf="altSourcesDetails.siteAndAreaLevel === 'Area Level'"
        >
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-form-field>
              <mat-select
                multiple
                formControlName="solarProcessesCtr"
                [(ngModel)]="altSourcesDetails.solarProcesses"
                placeholder="---  Select Processes  ---"
              >
                <mat-option
                  *ngFor="let solarProcesses of processesList"
                  [value]="solarProcesses"
                >
                  {{ solarProcesses }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-label class="label-input"
              >Number of Irradiance Sensors:<span class="iep-required"
                >*</span
              ></mat-label
            >
          </div>

          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-form-field>
              <input
                matInput
                type="number"
                name="inputNo"
                id="sensors"
                min="1"
                formControlName="sensorsinputNoCtr"
                [(ngModel)]="form.sensorsinputNo"
                required
                (change)="generateIrradianceSensorsForm(form.sensorsinputNo)"
              />
            </mat-form-field>
          </div>
        </div>

        <div
          *ngFor="
            let flowChannel of altSourcesDetails.inlets;
            let $index = index
          "
        >
          <div class="row">
            <div class="col-lg-2">
              <mat-label class="label-input"
                >Irradiance Sensor {{ $index + 1 }}
              </mat-label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2">
              <mat-label class="label-input">Sensor Name</mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  name="slrName_1"
                  fromControlName="altflowChannelNameCtr"
                  [(ngModel)]="flowChannel.name"
                  [ngModelOptions]="{ standalone: true }"
                  id="slrName_{{ $index }}"
                  required
                  placeholder="Sensor Name"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2">
              <mat-label class="label-input">Flow Channel Id</mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  fromControlName="altflowChannelIDCtr"
                  [(ngModel)]="flowChannel.flowChannelID"
                  [ngModelOptions]="{ standalone: true }"
                  id="slrFlowChannel_{{ $index }}"
                  required
                  placeholder="Flow Channel ID"
                />
              </mat-form-field>
            </div>
            <div class="col-lg-2">
              <mat-label class="label-input">Flow Channel Serial No.</mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  formControlName="altIoChannnelSerialNumberCtr"
                  [(ngModel)]="flowChannel.ioChannnelSerialNumber"
                  id="slrIOSrlNo_{{ $index }}"
                  required
                  placeholder="IO Channel Serial No"
                />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div *ngIf="altSourcesDetails.siteAndAreaLevel === 'Area Level'">
          <div class="row">
            <div class="col-lg-12">
              <mat-label class="label-input">3.Add Inverter</mat-label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <mat-label class="label-input">Number of Inverters:</mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  name="inputNo"
                  id="inverters"
                  min="1"
                  max="5"
                  required
                  formControlName="inverterinputNoCtr"
                  [(ngModel)]="form.inverterinputNo"
                  (change)="generateInvertersForm(form.inverterinputNo)"
                />
              </mat-form-field>
            </div>
          </div>
          <div
            *ngFor="
              let inverterVar of altSourcesDetails.inverterDetails;
              let $index = index
            "
          >
            <div class="row">
              <div class="col-lg-2">
                <mat-label class="label-input"
                  >Inverter Details {{ $index + 1 }}
                </mat-label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <mat-label class="label-input">Inverter Make</mat-label>
              </div>
              <div class="col-lg-3">
                <mat-form-field>
                  <input
                    matInput
                    type="text"
                    formControlName="invertermakeCtr"
                    [(ngModel)]="inverterVar.invertermake"
                    id="InverterMake"
                    placeholder="Inverter Make"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2">
                <mat-label class="label-input">Inverter Type</mat-label>
              </div>
              <div class="col-lg-3">
                <mat-form-field>
                  <input
                    matInput
                    type="text"
                    formControlName="varInverterTypeCtr"
                    [(ngModel)]="inverterVar.invertertype"
                    id="InverterType{{ $index }}"
                    placeholder="Inverter Type"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <mat-label class="label-input">Rating</mat-label>
              </div>
              <div class="col-lg-3">
                <mat-form-field>
                  <input
                    matInput
                    type="text"
                    formControlName="inverterratingCtr"
                    [(ngModel)]="inverterVar.inverterrating"
                    id="InverterRating{{ $index }}"
                    placeholder="Inverter Rating"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2">
                <mat-label class="label-input">No.of Inverters</mat-label>
              </div>
              <div class="col-lg-2">
                <mat-form-field>
                  <input
                    matInput
                    type="text"
                    formControlName="noOfInvertersCtr"
                    [(ngModel)]="inverterVar.noOfInverters"
                    id="noOfInverters{{ $index }}"
                    placeholder="No.of Inverters"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 label-input">
              <mat-label> Email </mat-label>
              <br />
              <mat-label> To List:</mat-label>
            </div>

            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <mat-select
                  multiple
                  formControlName="emailRecepientToListCtr"
                  [(ngModel)]="altSourcesDetails.emailRecepientToList"
                  placeholder="---  Select Receipients  ---"
                  [required]="true"
                >
                  <mat-option *ngFor="let email of emailList" [value]="email">
                    {{ email }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 label-input">
              <mat-label> Email </mat-label>
              <br />
              <mat-label> CC List:</mat-label>
            </div>

            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <mat-form-field>
                <mat-select
                  multiple
                  formControlName="emailRecepientCcListCtr"
                  [(ngModel)]="altSourcesDetails.emailRecepientCcList"
                  placeholder="---  Select Receipients  ---"
                >
                  <mat-option *ngFor="let email of emailList" [value]="email">
                    {{ email }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="label-input">
              <mat-label> Email </mat-label>
              <br />
              <mat-label> BCC List:</mat-label>
            </div>

            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pull-right">
              <mat-form-field>
                <mat-select
                  multiple
                  formControlName="emailRecepientBccListCtr"
                  [(ngModel)]="altSourcesDetails.emailRecepientBccList"
                  placeholder="---  Select Receipients  ---"
                >
                  <mat-option *ngFor="let email of emailList" [value]="email">
                    {{ email }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    </mat-expansion-panel>

    <!-- Strings and PV Modules -->
    <br />
    <mat-expansion-panel
      class="md-expansion-demo-width"
      #upsDetailsPanel
      expanded="true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title><h6>Strings and PV Modules</h6></mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="formPvModule" #formDirective="ngForm" novalidate>
        <div class="row">
          <div class="col-lg-3">
            <mat-form-field>
              <mat-select
                formControlName="altsiteAndAreaLevelCtr"
                [(ngModel)]="altSourcesForStringsAndModules.altsiteAndAreaLevel"
                placeholder="Select Level"
              >
                <mat-option value="">Select Level</mat-option>
                <mat-option
                  *ngFor="let option of siteAndAreaLevel"
                  value="{{ option }}"
                  >{{ option }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div
            *ngIf="
              altSourcesForStringsAndModules.altsiteAndAreaLevel ===
              'Area Level'
            "
          >
            <div class="col-lg-2">
              <mat-label class="label-input">Select Area</mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <mat-select
                  id="altsolarAreaNames"
                  (selectionChange)="getSelectedValue()"
                  formControlName="altsolarAreaNamesCtr"
                  [(ngModel)]="
                    altSourcesForStringsAndModules.altsolarAreaNames.name
                  "
                >
                  <mat-option value="">Select Area</mat-option>
                  <mat-option
                    *ngFor="let option of solarAreasOfThisSite"
                    value="{{ option.name }}"
                    >{{ option.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <mat-label class="label-input">1.Add Strings</mat-label>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-2">
            <mat-label class="label-input">Select Inverter </mat-label>
          </div>

          <div class="col-lg-3">
            <mat-form-field>
              <mat-select
                (selectionChange)="getStringsList()"
                formControlName="invertersMakeCtr"
                [(ngModel)]="altSourcesForStringsAndModules.invertersMake"
                placeholder="Inverter Make"
              >
                <mat-option value="">Inverter Make</mat-option>
                <mat-option
                  *ngFor="let option of InverterMakeList"
                  value="{{ option }}"
                  >{{ option }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-2">
            <mat-label class="label-input">Number of Strings: </mat-label>
          </div>
          <div class="col-lg-3">
            <mat-form-field>
              <input
                matInput
                type="number"
                name="StringinputNo"
                id="strings"
                min="1"
                max="5"
                formControlName="stringinputNoCtr"
                [(ngModel)]="form.stringinputNo"
                required
                (change)="generateStringsForm(form.stringinputNo)"
              />
              <mat-error
                *ngIf="
                  formPvModule.get('stringinputNoCtr').hasError('required')
                "
                class="help-block"
                >This field is required.</mat-error
              >
            </mat-form-field>
          </div>
        </div>

        <div
          *ngFor="
            let stringsVar of altSourcesForStringsAndModules.altstringDetails;
            let $index = index
          "
        >
          <div class="row">
            <div class="col-lg-2">
              <mat-label class="label-input"
                >String Details {{ $index + 1 }}</mat-label
              >
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2">
              <mat-label class="label-input">String Name </mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  formControlName="stringnameCtr"
                  [(ngModel)]="stringsVar.stringname"
                  id="stringName"
                  required
                  placeholder="String Name"
                />
                <mat-error
                  *ngIf="formPvModule.get('stringnameCtr').hasError('required')"
                  class="help-block"
                  >This field is required.</mat-error
                >
              </mat-form-field>
            </div>
            <div class="col-lg-2">
              <mat-label class="label-input">String Capacity</mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  formControlName="capacityCtr"
                  [(ngModel)]="stringsVar.capacity"
                  id="stringCapacity"
                  required
                  placeholder="String Capacity"
                />
                <mat-error
                  *ngIf="formPvModule.get('capacityCtr').hasError('required')"
                  class="help-block"
                  >This field is required.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 text-center">
            <button
              class="btn btn-success"
              id="addStringbtn"
              (click)="addString($event)"
            >
              Add String
            </button>
          </div>
        </div>

        <!-- 2.Add PV Modules -->
        <div class="row">
          <div class="col-lg-12">
            <mat-label class="label-input">2.Add PV Modules</mat-label>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-2">
            <mat-label class="label-input">Select String</mat-label>
          </div>

          <div class="col-lg-3">
            <mat-form-field>
              <mat-select
                formControlName="pvstringNameCtr"
                [(ngModel)]="altSourcesForStringsAndModules.stringName"
                placeholder="String Name"
              >
                <mat-option value="">String Name</mat-option>
                <mat-option
                  *ngFor="let option of StringNameList"
                  value="{{ option }}"
                  >{{ option }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-2">
            <mat-label class="label-input">Number of PV Modules:</mat-label>
          </div>
          <div class="col-lg-3">
            <mat-form-field>
              <input
                matInput
                type="number"
                name="pvModulesinputNo"
                id="pvModules"
                min="1"
                max="5"
                formControlName="pvModulesinputNoCtr"
                [(ngModel)]="form.pvModulesinputNo"
                required
                (change)="generatepvModulesForm(form.pvModulesinputNo)"
              />
              <mat-error
                *ngIf="
                  formPvModule.get('pvModulesinputNoCtr').hasError('required')
                "
                class="help-block"
                >This field is required.</mat-error
              >
            </mat-form-field>
          </div>
        </div>

        <div
          *ngFor="
            let pvmoduleVar of altSourcesForStringsAndModules.altmoduleDetails;
            let pvindex = index
          "
        >
          <div class="row">
            <div class="col-lg-2">
              <mat-label class="label-input"
                >PV Modules {{ pvindex + 1 }}</mat-label
              >
            </div>
          </div>

          <div class="row">
            <div class="col-lg-2">
              <mat-label class="label-input">Module Make</mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  formControlName="pvModuleMakeCtr"
                  [(ngModel)]="pvmoduleVar.pvModuleMake"
                  id="pvmodule"
                  required
                  placeholder="PV Module"
                />
                <mat-error
                  *ngIf="
                    formPvModule.get('pvModuleMakeCtr').hasError('required')
                  "
                  class="help-block"
                  >This field is required.</mat-error
                >
              </mat-form-field>
            </div>
            <div class="col-lg-2">
              <mat-label class="label-input">Module Type</mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <mat-select
                  formControlName="moduleTypeCtr"
                  [(ngModel)]="pvmoduleVar.moduleType"
                  placeholder="Module Type"
                >
                  <mat-option value="">Module Type</mat-option>
                  <mat-option
                    *ngFor="let option of moduleType"
                    value="{{ option }}"
                    >{{ option }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-2">
              <mat-label class="label-input">Module Wp</mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  formControlName="moduleWpCtr"
                  [(ngModel)]="pvmoduleVar.moduleWp"
                  id="modulewp"
                  required
                  placeholder="Module Wp"
                />
                <mat-error
                  *ngIf="formPvModule.get('moduleWpCtr').hasError('required')"
                  class="help-block"
                  >This field is required.</mat-error
                >
              </mat-form-field>
            </div>
            <div class="col-lg-2">
              <mat-label class="label-input">No.of Modules </mat-label>
            </div>
            <div class="col-lg-3">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  formControlName="noOfModulesCtr"
                  [(ngModel)]="pvmoduleVar.noOfModules"
                  id="moduleno"
                  required
                  placeholder="Module No"
                />
                <mat-error
                  *ngIf="
                    formPvModule.get('noOfModulesCtr').hasError('required')
                  "
                  class="help-block"
                  >This field is required.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 text-center">
            <button
              class="btn btn-success"
              id="addPVModulebtn"
              (click)="addPVModule()"
            >
              Add PV Module
            </button>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
    <mat-action-row>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
        <button
          (click)="previousStep($event)"
          bciprimarybutton
          class="button-primary"
          id="previousbtn"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-arrow-left-frame"
              style="width: max-content"
            ></mat-icon> </span
          >Previous
        </button>
        <button
          type="submit"
          bciprimarybutton
          class="button-primary"
          id="submitbtn"
          style="margin-left: 3px"
          [disabled]="UPSDetails.submitted"
          (click)="submitAlternateSourcesDetails()"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-checkmark-frame"
              style="width: max-content"
            ></mat-icon> </span
          >Submit
        </button>

        <button
          (click)="nextStep($event)"
          id="nextbtn"
          bciprimarybutton
          class="button-primary"
          style="margin-left: 3px"
        >
          Next
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-arrow-right-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
        </button>
      </div>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
